import React from "react";
import {connect} from "react-redux";
import VeritasHeader from "../../shared/VeritasHeader";
import {Button, Confirm, Grid, Modal, Popup} from "semantic-ui-react";
import Breadcrumb from "../../../common/partials/Breadcrumb/Breadcrumb";
import {fetchAllServices} from "../../data-services/actions/ServicesActions";
import {
    deleteCountry,
    fetchAllCountries,
    fetchCountryDetail,
    unmountCountryDetailPage
} from "../actions/CountriesActions";
import {fetchAllOrganizations} from "../../data-providers/actions/DataProviderActions";
import {setBreadCrumb} from "../../breadcrumb/BreadcrumbActions";
import CountryDetailInfo from "./CountryDetailInfo";
import CountryForm from "../../add-edit/components/CountryForm";
import {
    editOneCountry,
    toggleCountryModal,
    updatedCountryRefresh,
    validateCountryForm
} from "../../add-edit/actions/AddEditCountryActions";
import LastUpdated from "../../../common/partials/LastUpdated";
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class CountryDetailPage extends React.Component {

    state = {
        deleteWarning: false,
    }

    componentDidMount() {
        const {countryID} = this.props.params;
        this.props.getCountryDetail(countryID);

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/country-coverage', text: 'Countries' },
            service: { url: '', text: '' },
            source: { url: '', text: '' },
        })

        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.
        if (this.props.all_services.length === 0) {
            this.props.getAllServices();
        }
        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }
        if (this.props.all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {countryID} = this.props.params;
        const {countryDetail} = this.props;
        if (this.props.updatedCountry) {
            this.props.getCountryDetail(countryID);
            this.props.updatedCountryRefresh();
        }
        document.title = countryDetail.country_detail ? `Veritas - ` + countryDetail.country_detail.country_iso : '';

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/country-coverage', text: 'Countries' },
            service: { url: `/veritas/country-coverage/${countryID}`,
                text: countryDetail.country_detail ? countryDetail.country_detail.country_name : '' },
            source: { url: '', text: '' },
        });
    }

    componentWillUnmount() {
        this.props.unmountCountryDetail();
    }

    deleteCountryButtonClick = () => {
        this.setState({deleteWarning: true});
    }

    handleCancelCountryDelete = () => {
        this.setState({deleteWarning: false});
    }

    handleConfirmCountryDelete = () => {
        const {countryDetail} = this.props;
        this.props.deleteCurrentCountry(countryDetail.country_detail.id);
        this.setState({deleteWarning: false});
    }

    handleEditCountryButtonClick = () => {
        this.props.editCurrentCountry(this.props.countryDetail);
    }

    handleEditCountryCloseModal = () => {
        this.props.toggleEditCountryModal();
    }

    handleCountryFormSubmit = () => {
        const {countryObj, notesObj} = this.props;
        this.props.validateEditCountry(countryObj, notesObj);
    }

    get countryName() {
        const {countryDetail, canEdit} = this.props;

        return(
            <div className="header-container">
                <div className="title-alignment">
                    <span className="detail-name">
                        <h1>
                            {countryDetail.country_detail
                            ? countryDetail.country_detail.country_name + ' ('
                                + countryDetail.country_detail.country_iso + ')'
                            : ''}
                        </h1>
                    </span>
                    {canEdit
                        ? (<span className="buttons-alignment">
                            <Popup
                                content={"Edit"}
                                trigger={
                                    <Button
                                        onClick={this.handleEditCountryButtonClick}
                                        icon="edit outline"
                                    />
                                }
                            />
                            <Popup
                                content={"Delete"}
                                trigger={
                                    <Button
                                        onClick={this.deleteCountryButtonClick}
                                        color={"red"}
                                        icon="trash alternate outline"
                                    />
                                }
                            />
                        </span>)
                        : null
                    }
                </div>
                <div className="title-alignment">
                    <span className="buttons-alignment">
                        <div className="flex">
                            <label> Last Updated On: </label>
                            <LastUpdated lastUpdated={countryDetail.country_detail.last_updated}  />
                        </div>
                    </span>
                </div>
            </div>
        );
    }


    pageContent() {
        return (
            <div style={{padding: "20px 20px 0 30px"}}>
                <Grid relaxed={true}>
                    <Grid.Column width={11}>
                        <Breadcrumb/>
                        <div style={{padding: "20px 20px 0 20px"}}>
                            {this.countryName}
                            <CountryDetailInfo
                                countryDetail={this.props.countryDetail}
                                associatedKYCData={this.props.associatedKYCData}
                                associatedKYBData={this.props.associatedKYBData}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column width={5}>
                    {/*  For Additional Details Section  */}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    render() {
        const {countryDetail} = this.props;

        const confirmDeleteMessage = Object.keys(countryDetail).length === 0
            ? ``
            : `Are you sure you want to delete ${countryDetail.country_detail.country_name}?
            This action cannot be undone.`

        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {Object.keys(this.props.countryDetail).length === 0
                            ? null
                            : this.pageContent()
                        }
                    </Grid.Column>
                </Grid>


                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.toggleModal}
                >
                    <Modal.Header>
                        {"Edit Country Details"}
                    </Modal.Header>
                    <Modal.Content>
                        <CountryForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleEditCountryCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleCountryFormSubmit}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>


                <Confirm
                    open={this.state.deleteWarning}
                    content={confirmDeleteMessage}
                    onCancel={this.handleCancelCountryDelete}
                    onConfirm={this.handleConfirmCountryDelete}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,

    all_services: state.veritas.services.all_services,
    all_providers: state.veritas.providers.all_providers,
    all_organizations: state.veritas.providers.all_organizations,
    all_countries: state.veritas.countries.all_countries,

    countryDetail: state.veritas.countryDetail.country,
    associatedKYCData: state.veritas.countryDetail.associatedKYCData,
    associatedKYBData: state.veritas.countryDetail.associatedKYBData,
    associatedTenants: state.veritas.countryDetail.associatedTenants,

    countryObj: state.veritas.addEdit.addEditCountry.countryObject,
    notesObj: state.veritas.addEdit.addEditCountry.notesObject,
    toggleModal: state.veritas.addEdit.addEditCountry.toggleModal,
    updatedCountry: state.veritas.addEdit.addEditCountry.updatedCountry
});

const mapDispatchToProps = dispatch => ({
    getAllServices: () => { dispatch(fetchAllServices()) },
    getAllCountries: () => {dispatch(fetchAllCountries())},
    getAllOrganizations: () => { dispatch(fetchAllOrganizations()) },

    getCountryDetail: (countryID) => { dispatch(fetchCountryDetail(countryID)) },
    deleteCurrentCountry: (countryID) => {dispatch(deleteCountry(countryID))},
    editCurrentCountry: (countryDetail) => {dispatch(editOneCountry(countryDetail))},
    validateEditCountry: (countryObj, notesObj) => {dispatch(validateCountryForm(countryObj, notesObj))},
    toggleEditCountryModal: () => {dispatch(toggleCountryModal())},

    updatedCountryRefresh: () => {dispatch(updatedCountryRefresh())},
    unmountCountryDetail: () => { dispatch(unmountCountryDetailPage()) },
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountryDetailPage)
